<div class="container pt-3 fade-in-left" id="centerFrame">
    <div class="d-flex align-items-center justify-content-center mb-1 pe-5">
        <a (click)="back()"><div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div></a>
        <div class="p-2 flex-grow-1 pl-2"><h1 class="text-dark text-center ">ABM Prestaciones</h1></div>
    </div>

    <!-- Sections -->
    <div class="row-cols-12 m-2 mt-0">
        <div class="row p-0 p-md-3 mb-0 align-items-center pt-1">
            <div class="mt-0 text-start mb-3 pb-3">
                <div class="d-grid mb-3 p-2">
                    <button type="button" class="btn btn-primary btn-lg mt-0" [routerLink]="['/more-prestacion']">
                        <span class="icon">+ </span>
                        <span class="text">Agregar Prestacion</span>
                    </button>
                </div>

                <div class="row-cols-12 p-2 mb-3 ps-0 pe-0 input-group fade-in search-input-row">
                    <div class="rounded-start col-md-auto" id="search-addon">
                        <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2"><i class="bi bi-search"></i></div>
                    </div>
                    <div class="col rounded">
                        <input type="search" class="form-control search-input shadow-none" placeholder="Buscar por Prestación" aria-label="Search" aria-describedby="search-addon" (keyup)="searchTerm$.next($any($event.target).value)" />
                    </div>
                    <div class="col-md-auto rounded-end text-end col-md-auto" id="mic-addon">
                        <div class="mx-auto d-block p-1 d-inline-flex"><i class="bi bi-mic"></i></div>
                    </div>
                </div>

                <div class="mb-3">
                    <label class="form-label small text-muted mb-1">
                        Filtrar por especialidad
                    </label>
                    <div class="input-group">
                        <input
                            type="text"
                            class="form-control shadow-none"
                            placeholder="Todas las especialidades"
                            list="especialidades-datalist"
                            autocomplete="off"
                            [value]="especialidadFiltroTexto()"
                            (input)="onEspecialidadFiltroInput($any($event.target).value)"
                        />
                        @if (especialidadFiltroTexto()) {
                            <button type="button" class="btn btn-outline-secondary" (click)="limpiarFiltroEspecialidad()">
                                <i class="bi bi-x-lg"></i>
                            </button>
                        }
                    </div>
                    <datalist id="especialidades-datalist">
                        @for (especialidad of especialidades; track especialidad.id) {
                            <option [value]="especialidad.x_descripcion"></option>
                        }
                    </datalist>
                </div>

                @if (error()) {
                    <div class="alert alert-danger mt-4" role="alert">
                        <small>{{ error() }}</small>
                    </div>
                }
                @if (message()) {
                    <div class="alert alert-success mt-4" role="alert">
                        <small>{{ message() }}</small>
                    </div>
                }

                <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="p-0 m-0">
                        <b>Prestaciones ({{ (prestacionesFiltradas$ | async)?.length ?? 0 }})</b>
                    </span>

                    <button
                        type="button"
                        class="btn-export-excel"
                        title="Exportar Excel"
                        (click)="exportarExcel()"
                    >
                        <i class="bi bi-file-earmark-excel"></i>
                    </button>
                </div>
                @for (prestacion of (prestacionesFiltradas$ | async) ?? []; track prestacion.id) {
                    <div class="prestacion-card mt-3 form-switch">
                        <a class="text-decoration-none text-dark flex-grow-1"
                        [routerLink]="['/more-edit-prestacion/', prestacion.id]">

                            <div class="prestacion-title">
                                {{ prestacion.x_descripcion }}
                            </div>

                            <div class="prestacion-subtitle">
                                {{ prestacion.descripcionEspecialidad }}
                            </div>
                        </a>

                        <div class="col-auto">
                            <a [routerLink]="['/more-edit-prestacion/', prestacion.id]">
                                <i class="bi bi-pencil"></i>
                            </a>
                        </div>
                        <div class="col-auto">
                            <input
                                class="form-check-input ms-3"
                                [id]="prestacion.id"
                                type="checkbox"
                                [checked]="prestacion.b_activo"
                                (change)="activarDesactivar(prestacion, $any($event.target).checked)"
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</div>